export default __webpack_public_path__ + "src/images/packages/simbambili-lodge/5eef577dddce51bb30bcd4486185a870-4.jpg";